import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

export interface SortEvent {
    column: string;
    direction: SortDirection;
}

@Directive({
    selector: 'th[sbproSortable]',
})
export class SortableHeaderDirective {
    @Input() sbproSortable!: string;
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();

    @HostBinding('class.asc') get isAscending() {
        return this.direction === 'asc';
    }
    @HostBinding('class.desc') get isDescending() {
        return this.direction === 'desc';
    }
    @HostBinding('class.pointer')
    pointerClass = 'pointer';

    @HostListener('click') rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sbproSortable, direction: this.direction });
    }
}
